/*
 * @Descripttion:
 * @version:
 * @Author: guoye
 * @Date: 2023-11-01 13:54:07
 * @LastEditors: guoye
 * @LastEditTime: 2025-08-29 13:27:49
 */

// 根据平台设置平台功能配置
function setPlatformFunctionConfig(val) {
  let config = {
    registType: '1', //  1：商户进件  2：代理商进件, 默认为商户 jinjian
    needFaceRecognition: 'Y', // 支持人脸
    needBankCardAuth: 'Y', // 支持银行卡认证
    needMyLimit: 'Y', // 支持我的额度
    SUPPORT_PERSONAL_INFO: '1', // 是否还需要采集用户的身份信息 2：不需要, 1：需要 默认为 1
    useReceiveMerCode: 'N', // 使用接收的 merchantCode, 默认为 N
    needBankBelowImgUrl: 'N', // 需要借记卡背面照, 默认 N
    nativePlatform: val.nativePlatform,
    supportNativeScan: val.supportNativeScan || 'N', // 是否支持原生扫一扫
    phone: val.userId ? val.phone : null,
    // 原生安全区高度
    nativeSafeHeight:
      val.nativeSource == 'IOS' ? Math.ceil(Number(val.navBarHeight * 2)) : Math.ceil(Number(val.navBarHeight)),
  }
  if (val.agtMercId) {
    config.registType = '2'
    config.useReceiveMerCode = 'Y'
  }
  switch (val.nativePlatform) {
    case 'QSB':
      config.needBankBelowImgUrl = 'Y'
      break
    case 'KPHB':
    // 靠谱伙伴
    case 'DHB':
      // 道合宝
      config.needBankBelowImgUrl = 'Y' // 对私结算反面照
      // config.SUPPORT_PERSONAL_INFO = '2'
      // config.needBankCardAuth = 'N'
      // config.needFaceRecognition = 'N'
      break
  }

  return { ...config }
}
// 根据页面标签类型清空认证信息
function clearKycInfo() {
  const { pina_certificationInfo, pina_merchatInfo, pina_systemInfo, pina_displayMerchatInfo, pina_faceInfo } =
    storeToRefs(model.pinia_custom())

  const locObj = util_urlToObj(location.href)

  if (!locObj.KycTagType || (locObj.KycTagType && locObj.KycTagType != 'kyc')) {
    if (!pina_merchatInfo.value?.merchantCode) {
      pina_certificationInfo.value = {}
      pina_certificationInfo.value.pageType = 'add'
      if (!pina_faceInfo.value) pina_faceInfo.value = {}
    }
    pina_displayMerchatInfo.value = {}
    pina_merchatInfo.value = {}
    pina_merchatInfo.value.merchantCode = ''
    if (pina_systemInfo.value.useReceiveMerCode == 'Y') {
      pina_merchatInfo.value.merchantCode = val.merchantCode || ''
    }
  }
}

// 设置环境变量
function useEnvConfig(val) {
  /*
   * val 说明:
   * 1. SYS_ORG_CODE 系统组织代码
   * 2. SM2_PRIVATE_KEY 国密私钥
   * 3. SM2_PUBLICK_KEY 国密公钥
   * 4. DH_SOURCE 对称加密源
   * 5. NODE_ENV 环境变量
   * 6. OUT_CHANNEL 渠道
   * 7. nativePlatform 原生平台
   * 8. agtMercId 代理商商户ID
   * 9. userId 用户ID
   * 10. token 令牌
   * 11. phone 手机号
   * 12. backApp 返回应用 参数
   * 13. nativeSource 原生来源
   * 14. sourceFrom 来源
   * 15. navBarHeight 导航栏高度
   * 16. supportNativeScan 是否支持原生扫一扫
   * 17. merchantCode 商户代码
   * 18. ORG_CODE 组织代码
   */
  if (!val.ORG_CODE) return null

  const { Auth } = model.pinia_custom()
  const { pina_systemInfo, pina_faceCount } = storeToRefs(model.pinia_custom())
  const { pina_env_var } = storeToRefs(model.pinia_global())

  const env = import.meta.env

  const ENV_CONFIG = {
    ...env,
    ...val,
  }
  pina_env_var.value = { ...ENV_CONFIG }

  const platformConfig = setPlatformFunctionConfig(val)

  pina_systemInfo.value = {
    ...val,
    ...platformConfig,
  }
  // console.log(138, 'pina_systemInfo.value-->>>', pina_systemInfo.value)
  Auth.setToken(pina_systemInfo.value.token)

  pina_faceCount.value = 0
  // 如果当前页面没有kyc标签，则清空认证信息
  // 如果当前页面有kyc标签，则根据kyc标签类型清空认证信息
  // clearKycInfo()

  return {
    ENV_CONFIG,
    // platformConfig,
    // systemInfo: pina_systemInfo.value,
  }
}

export { useEnvConfig }
